'use strict';
import isFunction from 'lodash/isFunction';
import 'rxjs/add/operator/scan';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/throttleTime';
import {createEventHandler} from 'recompose';


export {createDimensionObserver} from './ObserveDimensions';

export function stopPropagation(e) {
  e.stopPropagation();
}

export function createToggleState(props$, initialState = false) {
  const {
    handler,
    stream,
  } = createEventHandler();

  const streamOut = stream
    .throttleTime(300, void 0, {leading: true, trailing: true})
    .startWith(initialState)
    .scan(toggle)
    .distinctUntilChanged()
    .takeUntil(props$.last());

  return {
    handler,
    stream: streamOut,
  };
}

function toggle(acc, curr) {
  if (curr === true) {
    return true;
  } else if (curr === false) {
    return false;
  } else {
    return !acc;
  }
}

export function createToggleOnceState(props$) {
  const {
    handler,
    stream,
  } = createEventHandler();

  const streamOut = stream
    .take(1)
    .startWith(false)
    .scan((acc, curr) => !acc)
    .takeUntil(props$.last());

  return {
    handler,
    stream: streamOut,
  };
}

export function persistEvent(e) {
  if (e && isFunction(e.persist)) {
    e.persist();
  }
}

export function getItemTitle(model) {
  if (!model) {
    return void 0;
  } else if (model.description) {
    return `${model.name}\n\n${model.description}`;
  } else {
    return model.name;
  }
}

/**
 * Check if the properties in stateChange differ from state.
 * Ignore properties in state that are not in stateChange.
 * @param state
 * @param stateChange
 * @returns {boolean}
 */
export function shouldStateUpdate(state, stateChange) {
  for (const key in stateChange) {
    if (stateChange.hasOwnProperty(key) && stateChange[key] !== state[key]) {
      return true;
    }
  }

  return false;
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/react-utils/index.js